import Model, { attr, hasMany } from '@warp-drive/legacy/model';

export default class CertificationReport extends Model {
  @attr('number') certificationCourseId;
  @attr('string') firstName;
  @attr('string') lastName;
  @attr('boolean') isCompleted;
  @attr('string') abortReason;

  @hasMany('certification-issue-report', { async: false, inverse: 'certificationReport' }) certificationIssueReports;

  get firstIssueReportDescription() {
    const firstIssueReport = this.certificationIssueReports[0];
    return firstIssueReport ? firstIssueReport.description : '';
  }

  get isInvalid() {
    return !this.isCompleted && this.abortReason === null;
  }

  toJSON() {
    return {
      id: this.id,
      certificationCourseId: this.certificationCourseId,
      firstName: this.firstName,
      lastName: this.lastName,
      isCompleted: this.isCompleted,
      abortReason: this.abortReason,
    };
  }
}
